import React from 'react';
import { PlayIcon } from 'lucide-react';
import { screenshots } from '../data/screenshots';
import type { MediaFrame } from '../data/screenshots';
interface MediaPlaceholderProps {
  /** Names the screenshot sequence that belongs in this slot. */
  label: string;
}
function Frame({
  frame,
  index,
  total
}: {
  frame: MediaFrame;
  index: number;
  total: number;
}) {
  return <figure className="overflow-hidden rounded-xl border border-white/10 bg-black/40" data-id="element-49" data-mp="ftkri38t5iee">
      <figcaption className="flex items-center gap-3 border-b border-white/10 px-4 py-3" data-id="element-50" data-mp="ksfktz4eipcr">
        {total > 1 && <span aria-hidden="true" className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md border border-[#10b981]/40 bg-[#10b981]/10 font-mono text-[10px] font-semibold text-[#10b981]" data-id="element-51" data-mp="prs9mpeu26hz">
            {index + 1}
          </span>}
        <span className="text-[13px] leading-snug text-white/80" data-id="element-52" data-mp="265qoniiilq06">{frame.caption}</span>
      </figcaption>
      <img src={frame.src} alt={frame.caption} loading="lazy" className="block h-auto w-full object-contain" data-id="element-53" data-mp="i8h12ejst16t" />
    </figure>;
}
export function MediaPlaceholder({
  label
}: MediaPlaceholderProps) {
  const frames = screenshots[label];
  if (frames && frames.length > 0) {
    return <div className="space-y-3" data-id="element-54" data-mp="47wgbcubovao">
        {frames.map((frame, index) => <Frame key={frame.src} frame={frame} index={index} total={frames.length} data-id="element-55" data-mp="3vezamd5gjhp4" data-mpi={index} />)}
      </div>;
  }
  return <div role="img" aria-label={`Media placeholder: ${label} — coming soon`} className="group/media relative flex aspect-video w-full flex-col items-center justify-center gap-3.5 overflow-hidden rounded-xl border border-dashed border-white/20 bg-black/40 px-5 text-center" data-id="element-56" data-mp="3qnhhgb9oelep">
      <span className="pointer-events-none absolute inset-0 bg-[radial-gradient(60%_70%_at_50%_45%,rgba(16,185,129,0.12),transparent_70%)]" data-id="element-57" data-mp="3cnpyrx87sgud" />
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full border border-[#10b981]/40 bg-[#10b981]/10 text-[#10b981] transition-transform duration-200 group-hover/media:scale-105" data-id="element-58" data-mp="37rrd4he9tcxn">
        <PlayIcon className="h-5 w-5 translate-x-[1px] fill-[#10b981]" aria-hidden="true" data-id="element-59" data-mp="32ystwx5zs3vv" />
      </span>
      <span className="relative font-mono text-[12.5px] font-semibold tracking-tight text-white sm:text-sm" data-id="element-60" data-mp="2t2zixi7x8ig7">
        {label}
      </span>
      <span className="relative font-mono text-[10px] uppercase tracking-[0.22em] text-white/50" data-id="element-61" data-mp="3gtlcy5l3c277">
        Walkthrough — coming soon
      </span>
    </div>;
}